import React from 'react';
import { 
    TouchableOpacity, 
    View, 
    Text, 
    StyleSheet, 
    // Modal, 
} from "react-native";

import Modal from './base/Modal';

// import Icon from 'react-native-ionicons';
import { Ionicons as Icon } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
import Colors from '../../constants/Colors'
import FontStyles from '../../constants/FontStyle';

const FeedbackModal = ({ modalState, hideModal }) => {
    const navigation = useNavigation()
    const clickAreaRef = React.useRef()

    const goto = (screen) => {
        hideModal()
        navigation.navigate(`${screen}`)
    }

    const handleClickOutside = e => {
        e.persist()
        if (clickAreaRef.current) {
            if (e.target === clickAreaRef.current._nativeTag) {
                hideModal()
            }
        }
    }

    return (
        <Modal
            presentationStyle='overFullScreen'
            animationType="slide"
            transparent={true}
            visible={modalState}
            onRequestClose={() => {
                hideModal()
            }}>
            <View
                ref={clickAreaRef}
                onStartShouldSetResponder={handleClickOutside}
                style={styles.overlay}
            >
                <View style={styles.container}>

                    <TouchableOpacity
                        style={styles.closeButton}
                        onPress={() => {
                            hideModal()
                        }} >
                        <Text style={styles.closeButtonText}>Close</Text>
                        <Icon name='md-close' size={24} color='#FFFFFF' />
                    </TouchableOpacity>

                    <View style={[styles.card, styles.successCard]}>

                        <Icon name='ios-checkmark-circle' size={57.75} color='#00A879' style={{ margin: 9.63 }} />
                        <Text style={[styles.cardBody, {
                            // height: 60,
                            width: 238,
                            letterSpacing: 0,
                            ...FontStyles.dark,
                            ...FontStyles.size14,
                            ...FontStyles.lh20,
                            ...FontStyles.normal,
                            textAlign: 'center',
                        }]}>Your feedback has been sent.</Text>

                        <TouchableOpacity
                            style={[styles.actionButton, { marginTop: 18 }]}
                            onPress={hideModal} >
                            <Text style={[styles.actionButtonText, { alignSelf: "center" }]}>OK</Text>
                        </TouchableOpacity>

                    </View>

                </View>
            </View>
        </Modal>
    )
}

export default FeedbackModal

const styles = StyleSheet.create({
    overlay: {
        backgroundColor: 'rgba(0,0,0,0.6)',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center'
    },
    container: {
        width: '100%',
        // paddingHorizontal: 16,
        justifyContent: 'center'
    },
    closeButton: {
        flexDirection: 'row',
        alignSelf: 'flex-end',
        marginBottom: 8,
        marginRight: 16,
    },
    closeButtonText: {
        color: Colors.whiteColor,
        ...FontStyles.size14,
        ...FontStyles.lh16,
        ...FontStyles.bold,
        alignSelf: 'center',
        marginRight: 8,
    },
    card: {
        borderTopLeftRadius: 25,
        borderTopRightRadius: 25,
        backgroundColor: '#FFFFFF',
        paddingHorizontal: 20,
        paddingTop: 24,
        paddingBottom: 16
    },
    successCard: {
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        borderBottomLeftRadius: 16,
        borderBottomRightRadius: 16,
        backgroundColor: '#FFFFFF',
        marginHorizontal: 16,
        alignItems: "center"
    },
    cardHeader: {
        height: 19,
        width: 157,
        color: '#171C34',
        ...FontStyles.size16,
        ...FontStyles.lh20,
        ...FontStyles.bold,
        marginBottom: 16,
    },
    cardBody: {
        width: 288,
        ...FontStyles.dark,
        ...FontStyles.size14,
        ...FontStyles.lh20,
        ...FontStyles.normal,
    },
    inputLabel: {
        height: 16,
        width: 85,
        color: Colors.shades._7,
        ...FontStyles.size14,
        ...FontStyles.lh16,
        ...FontStyles.bold,
        marginBottom: 7,
    },
    actionButton: {
        height: 36,
        width: '100%',
        borderRadius: 4,
        backgroundColor: '#3B54EC',
        marginBottom: 7,
        flexDirection: 'row',
        justifyContent: 'center',
        width: 258
    },
    actionButtonText: {
        marginVertical: 10,
        height: 16,
        color: Colors.whiteColor,
        ...FontStyles.size14,
        ...FontStyles.lh16,
        ...FontStyles.bold,
        alignSelf: 'center',
    },
    counterWrapper: {
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        paddingVertical: 4,
        paddingHorizontal: 6,
        borderColor: '#F6F6F6',
        borderWidth: 1,
        borderStyle: 'solid',
        borderRadius: 20,
        marginTop: 15,
    },
    counterBtn: {
        width: 34,
        height: 34,
        borderRadius: 17,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(96, 96, 96, 0.1)'
    },
    counterInput: {
        color: '#070B1F',
        fontSize: 16,
        fontWeight: 'bold',
        lineHeight: 22,
        paddingVertical: 0,
        marginHorizontal: 20,
        textAlign: "center"
    },
    priceText: {
        ...FontStyles.size22,
        ...FontStyles.lh26,
        ...FontStyles.bold,
        marginTop: 16,
    }
})